import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import {
  faqLegalCopy,
  idmeFaqLegalCopy,
  getEnrolledGroupedFAQs,
  getUnenrolledGroupedFAQs,
} from '../../../constants/constants';
import { Section } from './section';
import { useIdmeEnabled } from '../../../hooks/useIdmeEnabled';
import type { MilitaryDiscountDetails } from '../../../api/types';

interface FAQsProps {
  /* `militaryDiscountDetails`, absent until the query comes back - the render
  /* below says as much - so it is deliberately optional. */
  apiResponse?: MilitaryDiscountDetails | null;
  isEnrolled?: boolean;
}

/* `apiResponse` is still what says the page has loaded - there is nothing to
/* show before it arrives - but which set of FAQs to show comes from `isEnrolled`,
/* which the page resolves for the whole page at once. Reading enrollment off the
/* response here as well would put the "how to enroll" FAQs under a section
/* congratulating a customer who just verified. */
function FAQs({ apiResponse = null, isEnrolled = false }: FAQsProps) {
  const isTCChangesEnabled = !!useConfigService('ENABLE_TC_CHANGES');
  const enableHdPass = !!useConfigService('ENABLE_HD_PASS_VERBIAGE');
  const isIdmeEnabled = useIdmeEnabled();

  const faqOptions = { enableHdPass, isIdmeEnabled };
  const faqs = isEnrolled
    ? getEnrolledGroupedFAQs(faqOptions)
    : getUnenrolledGroupedFAQs(faqOptions);
  const legalCopy = isIdmeEnabled
    ? idmeFaqLegalCopy()
    : faqLegalCopy(isTCChangesEnabled);

  return (
    <div id="faqs">
      {apiResponse &&
        faqs.map((item, indx) => (
          <Section key={item.title} section={item} index={indx} />
        ))}
      <Typography variant="body-xs">{legalCopy}</Typography>
    </div>
  );
}

export default FAQs;
